<h1 class="title">Simulation search</h1>
<mat-card class="simulation-search-card">
  <app-common-table></app-common-table>
</mat-card>
